<template>
  <div class="rulebook-page">
    <h1 class="fg-blue">Ironworld<sup>&reg;</sup></h1>
    <p class="rulebook-p" >
      <strong class="phead1 phead-red">Ironworld&reg;</strong> is a small mythical planet on the east side of nowhere, somewhere in another dimension, by the Iron Galaxy. It's sun, Ironstar, a small red dwarf, has 4 planets that revolve around it, each rotating in retrograde. The closest is Fireworld, a charred piece of rock. Next is Ironworld, which has 2 moons, Moonworld&trade; and Lunaworld. Afterworld, a ringed gaseous giant with 4 moons (Te, Tu, Sha, & Tesi) comes next. Last is Netherworld, a frozen piece of rock.
    </p>
    <p class="rulebook-p sub-p">
      <strong class="phead-blue">Date Reckoning</strong> A grand conjunction of the planets occurs every 715 years. All dates are based from this (year 0). Fireworld revolves every 195 days, Ironworld every 336 days, Afterworld 572 days, and Netherworld 1155 days (an Ironworld day is 20hrs).
    </p>

    <p class="rulebook-p">
      <strong class="phead-red">Ironworld&reg;</strong> is technically backward, but knowledge and mental use of energy (mp's) are a fine art. There are  many  flourshing cultures, mystique and adventure at its finest. Diameter: 400mi. Gravity: 20<sub class="ew-hairthin">ft/s<sup>2</sup></sub>
    </p>
    <p class="rulebook-p sub-p">
      <strong class="fg-blue">The Norse <span class="fg-red">(E)</span></strong> inhabit Terravania, Kassalvania, Nodvania, and the Central Meadowlands. The traditional capitals are Empron or Kasson. Sometimes these two cities vie for power, forming the monarchist Northern Kingdom and the republic Kasson.
    </p>

    <p class="rulebook-p sub-p">
      <strong class="fg-blue">The Norsk <span class="fg-red">(K)</span></strong> inhabit Uppervania, Necrovania, Iron Hills,
      Mothia, and the Northern Coast. These people prefer to form city-states or confederations, most notably Tuksa, whose
      ruler is traditionally the Ironlord (Tuksa’s Charter grants them that right).
    </p>

    <p class="rulebook-p sub-p">
      <strong class="fg-blue">The Nors <span class="fg-red">(N)</span></strong> inhabit Aridvania, the Great Desert, the
      Badlands, the Southern Desert, the Blue Lowlands, and Travakia. They are imperialists that form city-states. In the
      Blue Lowlands and Travakia they form the Easter Empire Confederation, a naval power with twin capitals at Mustika
      and Travon.
    </p>

    <p class="rulebook-p sub-p">
      <strong class="fg-blue">The Sur <span class="fg-red">(S)</span></strong> inhabit the wildlands. They form capitalist
      city-states and are a natural enemy of the Norse. Their capital is Satchen. The The <strong></strong>
    </p>

    <p class="rulebook-p sub-p">
      <strong class="fg-blue">Dwarfs <span class="fg-red">(D)</span></strong>
      inhabit Orkania, the Coldlands, and the Uplands. They form highly organized kingdoms within the mountain ranges.
      Some live in underground cities, while others live on the surface in small, isolated villages. They tolerate men
      but hate elves with a passion.
    </p>

    <p class="rulebook-p sub-p">
      <strong class="fg-blue">Elves <span class="fg-red">(F)</span></strong>
      inhabit the Northlands, the Forest of Tuksa, and the Western Lowlands. They seldom form governments, rather living
      in tribes and clans, often in harmony with the forest.
    </p>

    <p class="rulebook-p">
      <strong class="phead1 phead-red">Moonworld<sup style="font-size: .35em">TM</sup></strong> is a frozen fairy tale land of forests,
      tundra, and bogs. It orbits Ironworld every month. (full moons are the last and first day of each month).
      Diameter: 120 mi. Gravity: 10<sub class="ew-hairthin" style="font-size: .7em">ft/s<sup>2</sup></sub>.
    </p>
    <p class="rulebook-p sub-p">
      <strong class="fg-blue">Norst <span class="fg-red">(T)</span></strong>
      inhabit the Moonworld. The traditional capital is Exitus, since only Evilvania is extensively populated.
    </p>

    <p class="rulebook-p">
      <strong class="phead1 phead-red">Lunaworld<sup style="font-size: .35em">TM</sup></strong>
      Lunarworld orbits every 3 months (full moons are the solstices/equinoxes plus/minus 2 days). Uninhabitable. Diameter: 40 mi.
    </p>
  </div>
</template>

<script setup>

</script>

<style scoped lang="scss">
@import '@/assets/styles/book/bookview';

p {
  font-size: 1em;
  color: #303030;
  margin-bottom: 15px;
}

</style>
